import { ReactNode } from 'react';

import { useContextMediaQuery } from '@core/context';
import { EActionAttribute, EColor, ETypographyVariant } from '@core/type';

import { Typography } from './Typography';

export const TableMobileHeadingText = ({ children }: { children: ReactNode }) => {
  const { isMobile } = useContextMediaQuery();

  if (isMobile) {
    return (
      <Typography
        color={EColor.PRIMARY}
        as={EActionAttribute.SPAN}
        variant={ETypographyVariant.H6}
        marginRight={'4px'}
      >
        {children}:
      </Typography>
    );
  }
  return null;
};
